import { render, staticRenderFns } from "./KoreanLabelEdit.vue?vue&type=template&id=2492fa16&scoped=true"
import script from "./KoreanLabelEdit.vue?vue&type=script&lang=js"
export * from "./KoreanLabelEdit.vue?vue&type=script&lang=js"
import style0 from "./KoreanLabelEdit.vue?vue&type=style&index=0&id=2492fa16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2492fa16",
  null
  
)

export default component.exports